import { Editor } from "@tinymce/tinymce-react";
import { Editor as TinyMCEEditor } from "tinymce";
import React from "react";

export interface RichTextEditorProps {
    placeholder?: string;
    value?: any;
    disabled?: boolean;
    onChange?: (value: any) => void;
}

const RichTextEditor: React.FC<RichTextEditorProps> = ({
    placeholder,
    value,
    disabled,
    onChange
}) => {
    return (
        <div style={disabled ? { opacity: "0.4" } : undefined}>
            <Editor
                onEditorChange={onChange}
                apiKey={process.env.REACT_APP_TINY_LICENCE}
                value={value}
                disabled={disabled}
                init={{
                    height: 300,
                    menubar: false,
                    forced_root_block: "",
                    deprecation_warnings: false,
                    newline_behavior: "linebreak",
                    element_format: "xhtml",
                    placeholder,
                    plugins: [
                        "advlist autolink lists link image charmap print preview anchor",
                        "searchreplace visualblocks code fullscreen",
                        "insertdatetime media table paste code help wordcount autoresize"
                    ],
                    toolbar: "undo redo | bold italic backcolor | removeformat |",
                    paste_postprocess: function (_plugin: any, args: any) {
                        args.node
                            .querySelectorAll("span")
                            .forEach(function (span: HTMLSpanElement) {
                                while (span.firstChild) {
                                    span.parentNode!.insertBefore(span.firstChild, span);
                                }
                                span.parentNode!.removeChild(span);
                            });
                    },
                    setup: function (editor: TinyMCEEditor) {
                        editor.on("keydown", function (e) {
                            if (e.keyCode === 13) {
                                e.preventDefault();
                                editor.execCommand("InsertLineBreak");
                            }
                        });
                        editor.on("PostProcess", function (e) {
                            e.content = e.content
                                .replace(/<\/p>/gi, "<br>")
                                .replace(/<p[^>]*>/gi, "")
                                .replace(/<\/div>/gi, "<br>")
                                .replace(/<div[^>]*>/gi, "")
                                .replace(/<\/span>/gi, "")
                                .replace(/<span[^>]*>/gi, "");
                            // Remove trailing <br> tags
                            e.content = e.content.replace(/(<br\s*\/?>)+$/i, "");
                            if (e.content === "&nbsp;" || e.content === "\u00a0") {
                                e.content = "";
                            }
                        });
                    }
                }}
            />
        </div>
    );
};

export default RichTextEditor;
